import { CmsContentTypeEnum, SectionNameEnum } from '@app/enums';

export const CMS_CONTENT_TYPE_TO_SECTION_MAP: Record<string, SectionNameEnum> = {
    [CmsContentTypeEnum.HERO]: SectionNameEnum.HeroSection,
    [CmsContentTypeEnum.PROMOTED_DESTINATIONS]: SectionNameEnum.DestinationSuggestionsSection,
    [CmsContentTypeEnum.HORIZONTAL_BANNER]: SectionNameEnum.HorizontalBanner,
    [CmsContentTypeEnum.PROMOTED_ACCOMMODATIONS]: SectionNameEnum.FeaturedAccommodationsSection,
};
